import { render, staticRenderFns } from "./Grenzuebertritt.vue?vue&type=template&id=4d6700d4&scoped=true"
import script from "./Grenzuebertritt.vue?vue&type=script&lang=ts"
export * from "./Grenzuebertritt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6700d4",
  null
  
)

export default component.exports